import { render, staticRenderFns } from "./salePaymentsSummary.vue?vue&type=template&id=94fd4074&"
import script from "./salePaymentsSummary.vue?vue&type=script&lang=js&"
export * from "./salePaymentsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports